import React from "react";
import { IResourceComponentsProps } from "@refinedev/core";
import Cw8Create from "components/cw8/Cw8Create";

export const FragmentTypesCreate: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = "fragmentType";
    return (
        <Cw8Create
            resourceName = {resourceName}
        ></Cw8Create>
    );
};